import React, { } from "react";
import { Link, useLocation,  } from "react-router-dom";
import {  useAuth } from "../../AuthContext/AuthContext";
import { Menu } from "antd";
import {

  FaShoppingCart,
  FaBook,
  FaUtensils,
  FaWater,
  FaBox,
  
  FaGlassCheers,
  FaUsers,
  FaQuestion,
} from "react-icons/fa";
import { BsPersonCircle } from "react-icons/bs";

import { Images } from "../../../assets/assets";
import { Code2Icon } from "lucide-react";


const Sidebar: React.FC = () => {
  const location = useLocation();

  const { logout } = useAuth();


  const getMenuItem = (key: string, label: string, icon: React.ReactNode) => (
    <Menu.Item
      key={key}
      icon={icon}
      style={{ height: "100%", borderRight: 0, color: "#75A7AD" }}>
      <Link to={key}>{label}</Link>
    </Menu.Item>
  );

  return (
    <div className=" bg-white w-[250px]   mt-[30px]">
      <div className="w-[250px]">
        <div className=" ">
          <img
            src={Images.LogoGreen2}
            alt=""
            className="max-w-full h-auto mb-[2rem] md:mb-0 ml-[10px]"
          />
        </div>

        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          style={{
            height: "100%",
            borderRight: 0,
            backgroundColor: "white",
          }}>
          {getMenuItem("/dashboard/orders", "Orders", <FaUsers />)}
          {getMenuItem(
            "/dashboard/promo-code",
            "Promo Codes",
            <Code2Icon />
          )}

          {getMenuItem(
            "/dashboard/managemembers",
            "Manage Members",
            <FaUsers />
          )}
          {getMenuItem("/dashboard/blogs", "Blogs", <FaBook />)}
          {getMenuItem("/dashboard/store", "Stores", <FaShoppingCart />)}
          {getMenuItem("/dashboard/recipes", "Recipes", <FaUtensils />)}
          {getMenuItem(
            "/dashboard/watermachines",
            "Water Machines",
            <FaWater />
          )}
          {getMenuItem("/dashboard/manageproducts", "Products", <FaBox />)}
          {getMenuItem(
            "/dashboard/accessories",
            "Accessories",
            <FaGlassCheers />
          )}
          {getMenuItem(
            "/dashboard/faqs",
            "FAQs",
            <FaQuestion />
          )}
          <Menu.Item key="/" onClick={logout} icon={<BsPersonCircle />}>
            Log Out
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
};

export default Sidebar;
